module.exports = __webpack_public_path__ + "static/media/ico-new-clientes.7c34a5f3.svg";